// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#f4f4f5","menuBg":"#636977","menuHover":"#263445","subMenuBg":"#232736","subMenuHover":"#263445"};